import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
export const Checkbox = ({ className, register, onChange }) => {
    return (_jsx("input", Object.assign({ className: cn(className), type: "checkbox" }, register, { onChange: (e) => {
            register.onChange(e);
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
        } })));
};
